import { createContext } from 'react';
import { decorate, observable, action, computed, toJS } from 'mobx';

import api from '../api';
import * as fn from '../utilities/_functions';

export class GroupPaymentCreate {
    groupId = null;
    purchases = [];
    data = {
        payments: [],
        paymentMethod: null,
        paymentDate: null,
        note: null,
        noteHtml: null,
    }
    isReady = false;
    hasUnsavedChanges = false;
    isSaving = false;
    cancelGroupPaymentCreate = null;

    initialize = (customerIds) => {
        const that = this;
        that.clear();

        return new Promise((resolve, reject) => {
            api.Purchases.list({
                parameters: [{
                    field: 'customerId',
                    value: customerIds.join(','),
                    operator: 'Contains',
                }, {
                    field: 'remainingBalance',
                    value: 0.0,
                    operator: '>'
                }, {
                    field: 'deactivatedDateUtc',
                    value: null,
                }],
                includeTotalCount: false,
            })
                .then(({ data }) => {
                    if (data && data.result && data.result.length > 0) {
                        that.purchases = data.result;
                        that.data.payments = data.result.map(r => {
                            return {
                                id: r.id,
                                value: r.remainingBalance,
                            }
                        })
                    }
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isReady = true;
                    that.isSaving = false;
                    that.hasUnsavedChanges = false;
                })
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            const option = {
                payments: that.data.payments,
                paymentMethod: that.data.paymentMethod,
                paymentDate: that.data.paymentDate.format('YYYY-MM-DDTHH:mm:ss'),
            };

            if (that.data.note && that.data.noteHtml) {
                option.note = {
                    noteType: 'TransactionPayment',
                    preview: that.data.note,
                    bodyHtml: that.data.noteHtml,
                };
            }

            api.Payments.group(option, (c) => { that.cancelGroupPaymentCreate = c })
                .then(() => {
                    const data = toJS(option.payments);
                    that.hasUnsavedChanges = false;
                    that.clear();
                    resolve(data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isSaving = false;
                })

        })
    }

    clear = () => {
        this.groupId = null;
        this.purchases = [];
        this.data.paymentMethod = null;
        this.paymentDate = null;
        this.note = null;
        this.isReady = false;
        this.hasUnsavedChanges = false;
        this.isSaving = false;

        if (fn.isFunction(this.cancelGroupPaymentCreate)) {
            this.cancelGroupPaymentCreate();
            this.cancelGroupPaymentCreate = null;
        }
    }

    get total() {
        const that = this;
        return that.purchases && that.purchases.length > 0 ? that.purchases.reduce((total, purchase) => total + (purchase.total || 0.0), 0.0) : 0.0;
    }

    get remainingBalance() {
        const that = this;
        return that.purchases && that.purchases.length > 0 ? that.purchases.reduce((remainingBalance, purchase) => remainingBalance + (purchase.remainingBalance || 0.0), 0.0) : 0.0;
    }

    get amount() {
        const that = this;
        return that.data.payments && that.data.payments.length > 0 ? that.data.payments.reduce((amount, payment) => amount + (payment.value || 0.0), 0.0) : 0.0;
    }
}

decorate(GroupPaymentCreate, {
    groupId: observable,
    purchases: observable,
    data: observable,
    isReady: observable,
    hasUnsavedChanges: observable,
    isSaving: observable,
    initialize: action,
    save: action,
    clear: action,
    total: computed,
    remainingBalance: computed,
    amount: computed,
})

export default createContext(new GroupPaymentCreate());